import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { BLOG_STATUS_TRANSITION_TYPE } from '../../constants/enums/blog.enum.constant'
import { BlogDetailInterface, BlogFormInterface } from '../../interfaces/blog'
import BlogFormHandlerBar from './BlogFormHandlerBar'
import BlogFormMainBody from './BlogFormMainBody'

const BlogForm = ({
  blogDetail,
  formHandlers,
  disableForm,
  newForm
}: {
  blogDetail: BlogDetailInterface
  formHandlers: {
    createBlog: (createdBlog: BlogFormInterface) => void
    updateBlog: (updatedBlog: BlogFormInterface) => void
    statusChangeHandlerGenerator: (
      action: keyof typeof BLOG_STATUS_TRANSITION_TYPE
    ) => () => void
  }
  disableForm: boolean
  newForm: boolean
}) => {
  const methods = useForm<BlogFormInterface>({
    defaultValues: {
      ...blogDetail
    }
  })
  const { handleSubmit } = methods

  return (
    <FormProvider {...methods}>
      <form>
        <BlogFormHandlerBar
          saveHandler={handleSubmit(formHandlers.updateBlog)}
          createHandler={handleSubmit(formHandlers.createBlog)}
          statusChangeHandler={formHandlers.statusChangeHandlerGenerator}
          disableForm={disableForm}
          newForm={newForm}
          blogStatus={blogDetail?.status}
        />
        <BlogFormMainBody blogDetail={blogDetail} />
      </form>
    </FormProvider>
  )
}

export default BlogForm
